import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export const PathParametersSchema = z.object({
	Id: z.string(),
});
export type PathParameters = z.infer<typeof PathParametersSchema>;

// No QueryParameters

// No RequestBody

// No ResponseData

export async function callApi(input: { pathParameters: PathParameters }): Promise<Optional<void>> {
	const url: string = SERVICEBASEURL.BACKEND + `/Accessory/Restore/${input.pathParameters.Id}`;
	return await axios.post(url).toOptionalVoid();
}
